import store from './store'
import * as _ from 'lodash'
import { CustomError } from './interfaces/customError'
import { Confirm } from './interfaces/confirm.interface'
import axios from 'axios'
export default {
  handleError (err : any, opt = { }) : string {
    if (axios.isCancel(err)) {
      return ''
    } else if (err === 'cancel') {
      return ''
    }
    let message = _.get(err, 'response.data.message')
    let type = 'warning'
    let isShowToast = true
    if (err instanceof CustomError) {
      message = err.message
    }
    const status = _.get(err, 'response.data.statusCode')
    const responseURL = _.get(err, 'request.responseURL')
    const token = localStorage.getItem('token')
    if (responseURL && !responseURL.includes('auth/login') && !token) {
      console.log('No token!')
      isShowToast = false
    } else if (status === 401 && token) {
      message = 'Та дахин нэвтэрнэ үү.'
      localStorage.removeItem('token')
      store.dispatch('set_user', null)
    } else if (message) {
      type = 'error'
    } else {
      console.error(err)
      message = 'Системд ямар нэгэн алдаа гарлаа.'
      type = 'error'
    }
    if (isShowToast) {
      this.showToast(message, type, '')
    }
    return message
  },
  customError (msg : string) : void {
    throw new CustomError(msg)
  },
  showToast (message: string, type: string, title: string) : void {
    store.dispatch('show_toast', { message, type, title })
  },
  showConfirm (data : Confirm) : Promise<void> {
    return store.dispatch('show_confirm', data)
  },
  hideConfirm () : void {
    store.dispatch('hide_confirm')
  },
  searchCustomerContracts (registerNum : string) : Promise<any> {
    return store.dispatch('customer_contracts', registerNum)
  }
}
